export const MAX_DETAIL_STEPS = 5
export const MAX_DETAIL_RULES = 6

export const PAGE_TITLE_MAX = 30
export const PAGE_DESCRIPTION_MAX = 90
export const DETAIL_STEP_TEXT_MAX = 100
export const DETAIL_RULE_TEXT_MAX = 250

export const VISUAL_TITLE_MAX = 50
export const VISUAL_DESCRIPTION_MAX = 50

export const EXTRACT_DESCRIPTION_MAX = 44

export const MAX_FILE_SIZE_BYTES = 1024 * 1024 * 2 // 2MB
